<template>
  <card>
    <div slot="header" class="row align-items-center">
      <div class="col">
        <h3 class="mb-0">Editar perfil </h3>
      </div>

    </div>

    <form>
      <h6 class="heading-small text-muted mb-4">Información de Usuario</h6>

      <div>
        <div class="px-lg-4">




          <div class="row">
            <div class="col-lg-6">
              <base-input
                type="text"
                label="Nombre Corto"
                v-model="dataUserActual.shortName"
              >
              </base-input>
            </div>
            <div class="col-lg-6">
              <base-input
                type="email"
                label="Correo / Login"
                v-model="dataUserActual.email"
              >
              </base-input>
            </div>
          </div>

          <div class="row">
            <div class="col-lg-6">
              <base-input
                type="text"
                label="Nombre"
                v-model="dataUserActual.name"
              >
              </base-input>
            </div>
            <div class="col-lg-6">
              <base-input
                type="text"
                label="Apellido"
                v-model="dataUserActual.lastName"
              >
              </base-input>
            </div>
          </div>


           <div class="row">
            <div class="col-lg-6">
              <base-input
                type="text"
                label="RUT"
                v-model="dataUserActual.customer.rut"/>
            </div>
            <div class="col-lg-6">
              <base-input
                type="text"
                label="Direccion"
                v-model="dataUserActual.customer.adress"/>
            </div>
          </div>

          <div class="row">
            <div class="col-lg-6">
              <base-input
                type="password"
                label="Contraseña"
                v-model="dataUserActual.password"/>
            </div>
            <div class="col-lg-6">
              <base-input
                type="password"
                label="Verificar Contraseña"
                v-model="dataUserActual.password"/>
            </div>
          </div>


        </div>
        <hr class="my-4">

        <div class="px-lg-4">
          <div class="row">
            <div class="col-md-4">
              <label class="form-control-label d-block">
                País
              </label>
              <el-select class="select-danger"
                placeholder="Elegir País"
                v-model="selects.simple">
                <el-option v-for="option in selects.paises"
                          class="select-danger"
                          :value="option.name"
                          :label="option.name"
                          :key="option.name">
                </el-option>
              </el-select>
            </div>
            <div class="col-md-4">
              <label class="form-control-label d-block">
                Idioma
              </label>
              <el-select class="select-danger"
                placeholder="Elegir Idioma"
                v-model="selects.simpleIdioma">
                <el-option v-for="option in selects.idioma"
                          class="select-danger"
                          :value="option.name"
                          :label="option.name"
                          :key="option.name">
                </el-option>
              </el-select>
            </div>
            <div class="col-md-4">
              <label class="form-control-label d-block">
                Zona Horaria
              </label>
              <el-select class="select-danger"
                placeholder="Elegir Zona Horaria"
                v-model="selects.simpleZona">
                <el-option v-for="option in selects.zonaHoraria"
                          class="select-danger"
                          :value="option.name"
                          :label="option.name"
                          :key="option.name">
                </el-option>
              </el-select>
            </div>
          </div>
        </div>
      </div>

      <div v-show="(dataUserActual.adminUser==true)">
        <hr class="my-5">

        <h6 class="heading-small text-muted mb-4">Límite SMS</h6>

        <base-alert type="celcompink" class="mb-4">
            Los créditos total disponibles: <strong>{{ numberWithCommas(dataUserActual.customer.remainingSms) }}</strong>
        </base-alert>

        <div class="px-lg-4">

          <div class="row">
            <div class="col-md-6 mb-md-5">
              <base-radio name="checked" v-model="radio.radio1">
                Límite propio
                <el-tooltip content="Consumir créditos de tu límite propio" placement="top">
                  <i class="btn-tooltip fas fa-question-circle"></i>
                </el-tooltip>
              </base-radio>

            </div>

            <div class="col-md-6">
              <base-input type="text"
                          class="mb-0"
                          :disabled="radio.radio1=='unchecked'"
                          v-model="dataUserActual.remainingSms"
                          />
              <small>Restantes</small>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <base-radio name="unchecked" class="mb-3" v-model="radio.radio1">
                Límite cuenta master
              </base-radio>
            </div>
          </div>
        </div>

        <div class="pl-lg-4 text-right">
          <base-button type="celcomblue" @click="editarInfoCuenta">Guardar</base-button>
        </div>
      </div>

    </form>

  </card>

</template>

<script>
import { Select, Option } from 'element-ui'
import { BasePagination, Modal, Dialog } from '@/components';
import swal from 'sweetalert2'
import 'sweetalert2/dist/sweetalert2.css'

import moment from 'moment';

import AES256 from 'aes-everywhere';
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Config from '@/config/config.js'
import { getUser, setUser, encryptAES, horaAhora } from '@/util/util.js';

Vue.use(VueAxios, axios)
Vue.use(Dialog)

export default {
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    Modal,
    Dialog
  },
  data() {
    return {
      dataUser: {},
      dataUserActual: getUser(),
      radio: {
        radio1: "checked",
      },
      checkboxes: {
        unchecked: false,
        checked: true,
        uncheckedDisabled: false,
        checkedDisabled: true
      },
      selects: {
        simple: '',
        paises: [],
        simpleIdioma: '',
        idioma: [],
        simpleZona: '',
        zonaHoraria: []
      },
    };
  },
  methods: {
    obtenerInfoCustomer() {

    let self = this;
    let user = getUser();

      let js = {
      "time_expired":horaAhora(),
      "customer":encodeURIComponent(JSON.stringify(user.customer))
    }

    var body = new URLSearchParams(); body.append('TOKEN', (encryptAES(js)));

    Vue.axios.post(Config.url_service+Config.costumer_user_available, body, {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    })
      .then(function (response) {

          if (response.data.response == "200") {

            self.dataUser = response.data.data;


           self.dataUser.forEach(function(element) {
              if(element.customerUserId === user.customerUserId) {

                  self.selects.paises.push({'name':element.customer.country.name})
                  self.selects.zonaHoraria.push({'name':element.customer.country.gmt_timezone_name+"|"+element.customer.country.gmt_timezone_interval})
                  self.selects.simple = element.customer.country.name
                  self.selects.simpleZona = element.customer.country.gmt_timezone_name+"|"+element.customer.country.gmt_timezone_interval
                  self.selects.simpleIdioma = element.customer.language.name

                  self.radio.radio1 = (element.smsAdminUser) ? "unchecked" : "checked";

                  self.dataUserActual = element;
              }
            })

          } else {
            console.log("No se encontró usuario");

            swal({
                title: 'No se encontró usuario',
                buttonsStyling: false,
                confirmButtonClass: 'btn btn-danger',
                type: 'warning',
              })
          }

          self.$loading.hide()

      })
      .catch(function (error) {
          console.log("No se encontró usuario",error);

          swal({
                title: 'No se encontró usuario',
                buttonsStyling: false,
                confirmButtonClass: 'btn btn-danger',
                type: 'warning',
              })

          self.$loading.hide()
      });

    },
    obtenerPaises() {

    let self = this;

    let js = {
      "time_expired":horaAhora(),
    }

    var body = new URLSearchParams(); body.append('TOKEN', (encryptAES(js)));

    Vue.axios.post(Config.url_service+Config.country_available, body, {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    })
      .then(function (response) {

          if (response.data.response == "200") {

            self.selects.paises = response.data.data;
            console.log(response.data.data)


          } else {
            console.log("No se encontraron paises");
          }

          self.$loading.hide()

      })
      .catch(function (error) {
          console.log("No se encontraron paises",error);

          self.$loading.hide()
      });

    },
    obtenerIdiomas() {

    let self = this;

    let js = {
      "time_expired":horaAhora(),
    }

    var body = new URLSearchParams(); body.append('TOKEN', (encryptAES(js)));

    Vue.axios.post(Config.url_service+Config.language_available, body, {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    })
      .then(function (response) {

          if (response.data.response == "200") {

            self.selects.idioma = response.data.data;
            console.log(response.data.data)


          } else {
            console.log("No se encontraron paises");
          }

          self.$loading.hide()

      })
      .catch(function (error) {
          console.log("No se encontraron paises",error);
          self.$loading.hide()
      });

    },
    editarInfoCuenta(){

      this.$loading.show()

      let self = this;
      let user = getUser();


       if(this.dataUserActual.name=="" || this.dataUserActual.lastName=="" || this.dataUserActual.email=="" || this.dataUserActual.password=="" || this.dataUserActual.shortName=="" || (this.dataUserActual.remainingSms=="" && self.radio.radio1=="checked")){
         this.$loading.hide()
          swal({
            title: "Error Debe completar todos los campos",
            buttonsStyling: false,
            confirmButtonClass: 'btn btn-danger btn-fill'
          })
          return false;
      }


      var  zonaTime =  self.selects.simpleZona.split("|");
      this.dataUserActual.customer.country.gmt_timezone_name=zonaTime[0];
      this.dataUserActual.customer.country.gmt_timezone_interval=zonaTime[1];

      this.dataUserActual.smsAdminUser = (self.radio.radio1=="unchecked") ? "true":"false"

      let js = {
        "time_expired":horaAhora(),
        "customer":encodeURIComponent(JSON.stringify(this.dataUserActual.customer)),
        "customer_user":encodeURIComponent(JSON.stringify(this.dataUserActual))
      }

      var body = new URLSearchParams(); body.append('TOKEN', (encryptAES(js)));

      Vue.axios.post(Config.url_service+Config.costumer_user_edit, body, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      })
        .then(function (response) {
            console.log(response)
            if (response.data.response == "200") {

              self.dataUser = response.data.data;

              self.dataUser.forEach(function(element) {
                if(element.customerUserId === user.customerUserId) {

                    self.dataUserActual = element;
                    setUser(element);
                }
              })

              self.element = response.data.data;
              swal({
                title: '¡Datos editados con éxito!',
                buttonsStyling: false,
                confirmButtonClass: 'btn btn-success',
                type: 'success',
              })

            } else {
              console.log("No se editó usuario");
              swal({
                title: 'No se editó usuario',
                buttonsStyling: false,
                confirmButtonClass: 'btn btn-danger',
                type: 'warning',
              })
            }

            self.$loading.hide()

        })
        .catch(function (error) {
            console.log("No se editó usuario",error);
            swal({
              title: 'No se editó usuario',
              buttonsStyling: false,
              confirmButtonClass: 'btn btn-danger',
              type: 'warning',
            })

            self.$loading.hide()
        });

    },
    fechaFormato(unixTimestamp) {
      return moment(unixTimestamp).format('YYYY-MM-DD HH:mm:ss');
    },
    numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    onBlurNumber(e) {
      this.temp = this.dataUserActual.remainingSms;
      this.dataUserActual.remainingSms = this.thousandSeprator(this.dataUserActual.remainingSms);
    },
    thousandSeprator(amount) {
    	if (this.dataUserActual.remainingSms !== '' || this.dataUserActual.remainingSms !== undefined || this.dataUserActual.remainingSms !== 0 || this.dataUserActual.remainingSms !== '0' || this.dataUserActual.remainingSms !== null) {
        return this.dataUserActual.remainingSms.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      } else {
          return this.dataUserActual.remainingSms;
      }
    }
  },
    created() {
     this.obtenerInfoCustomer();
     // this.obtenerPaises();
      this.obtenerIdiomas();
    }
};
</script>
<style></style>
